import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, output, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PopupCloseComponent } from './popup-close.component';

@Component({
  selector: 'app-booking',
  imports: [PopupCloseComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './booking.component.html',
})
export class BookingComponent {
  private readonly document = inject(DOCUMENT);

  open = input(false);
  closed = output();

  emailCopied = signal(false);

  constructor() {
    effect(() => {
      this.document.body.style.overflow = this.open() ? 'hidden' : '';
    });
    inject(DestroyRef).onDestroy(() => (this.document.body.style.overflow = ''));
  }

  close() { this.closed.emit(); }

  async copyEmail() {
    await navigator.clipboard.writeText('booking@highheatrocks.com');
    this.emailCopied.set(true);
    setTimeout(() => this.emailCopied.set(false), 2000);
  }
}
